import lazyWithRetry from '../utils/lazyWithRetry';

const routerConfig = {
  '/exception/403': {
    component: lazyWithRetry(() => import('../routes/Exception/403')),
    key: '403',
    routes: [],
  },
  '/exception/404': {
    component: lazyWithRetry(() => import('../routes/Exception/404')),
    key: '404',
    routes: [],
  },
  '/exception/500': {
    component: lazyWithRetry(() => import('../routes/Exception/500')),
    key: '500',
    routes: [],
  },
  '/reset/:resetToken': {
    component: lazyWithRetry(() => import('../routes/Auth/ResetPassword')),
    key: 'resetPassword',
    routes: [],
  },
  '/handle-oauth-login': {
    component: lazyWithRetry(() => import('../routes/Auth/OauthHandler')),
    key: 'oauthLogin',
    routes: [],
  },
  '/terms': {
    component: lazyWithRetry(() => import('../routes/Terms/TermsOfService')),
    key: 'termsOfService',
    routes: [],
  },
  '/login': {
    component: lazyWithRetry(() => import('../routes/Auth/Login')),
    key: 'authLogin',
    routes: [],
  },
  '/legacy-login': {
    component: lazyWithRetry(() => import('../routes/Auth/LegacyLogin')),
    key: 'authLegacyLogin',
    routes: [],
  },
  '/forgot-password': {
    component: lazyWithRetry(() => import('../routes/Auth/ForgotPassword')),
    key: 'forgotPassword',
    routes: [],
  },
  '/password-reset-success': {
    component: lazyWithRetry(() => import('../routes/Auth/PasswordResetSuccess')),
    key: 'passwordResetSuccess',
    routes: [],
  },
  '/bookings/:bookingId': {
    component: lazyWithRetry(() =>
      import('../routes/OrganizationDashboard/BookingOverview/LandingPage')
    ),
    key: 'booking-landing',
    routes: [],
  },
  '/organization': {
    component: lazyWithRetry(() => import('../layouts/OrganizationDashboard')),
    key: 'organization-dashboard',
    routes: [
      {
        path: '/organization/student-groups/:classId',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/StudentGroups/StudentGroups')
        ),
        key: 'student-groups',
        exact: true,
      },
      {
        path: '/organization/home',
        component: lazyWithRetry(() => import('../routes/OrganizationDashboard/ClassDashboard')),
        key: 'organization-home',
        exact: true,
      },
      {
        path: '/organization/profile',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/UserProfile/UserProfile')
        ),
        key: 'profile',
        exact: true,
      },
      {
        path: '/organization/classes/activities/:classId',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/ClassActivityDashboard/ClassActivityDashboard')
        ),
        key: 'class-activities',
        exact: true,
      },
      {
        path: '/organization/classes/aggregated-performance/:classId',
        component: lazyWithRetry(() =>
          import(
            '../routes/OrganizationDashboard/ClassLessonPerformance/ClassLessonPerformanceDashboard'
          )
        ),
        key: 'class-aggregated-performance',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/aggregate-performance/:classId',
        component: lazyWithRetry(() =>
          import(
            '../routes/OrganizationDashboard/ClassLessonPerformance/ClassLessonPerformanceDashboard'
          )
        ),
        key: 'class-aggregate-performance',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/student-activities/:classId',
        component: lazyWithRetry(() =>
          import(
            '../routes/OrganizationDashboard/ClassStudentEngagement/ClassStudentEngagementDashboard'
          )
        ),
        key: 'class-student-activities',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/goals/:classId',
        component: lazyWithRetry(() => import('../routes/OrganizationDashboard/ClassGoals')),
        key: 'class-goals',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/import/manual',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/ClassImport/Manual')
        ),
        key: 'class-import-manual',
        exact: true,
      },
      {
        path: '/organization/classes/import/google-classroom',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/ClassImport/GoogleClassroom')
        ),
        key: 'class-import-via-google-classroom',
        exact: true,
      },
      {
        path: '/organization/detail',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/OrganizationDetail/OrganizationDetail')
        ),
        key: 'organization-detail',
        exact: true,
      },
      {
        path: '/organization/:userId/profile',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/StudentProfile/StudentProfile')
        ),
        key: 'profile',
        exact: true,
      },
      {
        path: '/organization/:userId/profile/:archiveClassId',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/StudentProfile/ArchivedClass')
        ),
        key: 'archived-class',
        exact: true,
      },
      {
        path: '/organization/:userId/vocabs',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/OrganizationDetail/VocabList')
        ),
        key: 'vocab-list',
        exact: true,
      },
      {
        path: '/organization/:userId/writing-pad',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/OrganizationDetail/WritingPad')
        ),
        key: 'writing-pad',
        exact: true,
      },
      {
        path: '/organization/library',
        component: lazyWithRetry(() => import('../routes/OrganizationDashboard/Library')),
        key: 'organization-library',
        exact: true,
      },
      {
        path: '/organization/my-exercises',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/MyExercises/MyExercises')
        ),
        key: 'my-exercises',
        exact: true,
      },
      {
        path: '/organization/quizzes/quiz/:quizId?/edit-translation',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/Quizzes/EditQuizTranslation')
        ),
        key: 'edit-quiz-translation',
        exact: true,
      },
      {
        path: '/organization/quizzes/quiz/:quizId?',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/Quizzes/CreateUpdateQuiz')
        ),
        key: 'create-update-quiz',
        exact: true,
      },
      {
        path: '/organization/quizzes/quiz/:quizId?/edit',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/ContentEditing/EditQuiz')
        ),
        key: 'edit-quiz',
        exact: true,
      },
      {
        path: '/organization/bookings/:bookingId/new-aggregation-view',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/Booking/NewBookingAggregation')
        ),
        key: 'new-booking-aggregation-view',
      },
      {
        path: '/organization/bookings/:bookingId/admin-tool',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/Booking/BookingAdminTool/BookingAdminTool')
        ),
        key: 'booking-admin-tool',
        exact: true,
      },
      {
        path: '/organization/bookings/:bookingId',
        component: lazyWithRetry(() => import('../routes/OrganizationDashboard/BookingOverview')),
        key: 'booking-overview',
        exact: true,
      },
      {
        path: '/organization/self-study-booking/:lessonId',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/SelfStudyBookingOverview')
        ),
        key: 'self-study-booking-overview',
      },
      {
        path: '/organization/classes/:id',
        component: lazyWithRetry(() => import('../routes/OrganizationDashboard/Classes/EditClass')),
        key: 'editClass',
        exact: true,
      },
      {
        path: '/organization/bundles/:bundleId/book',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Bundles/BundleBookingPage/BundleBookingPage')
        ),
        key: 'bundle-book',
        exact: true,
      },
      {
        path: '/organization/booking-cart',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/BookingCart/BookingCartPage')
        ),
        key: 'booking-cart',
        exact: true,
      },
      {
        path: '/organization/bundles',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Bundles')),
        key: 'bundles',
        exact: true,
      },
      {
        path: '/organization/:organizationId?/stats/sessions-usage',
        redirect: '/organization/:organizationId?/stats/session-usage',
        key: 'organization-stats-sessions-usage',
        exact: true,
      },
      {
        path: '/organization/:organizationId?/stats/session-usage',
        component: lazyWithRetry(() =>
          import(
            '../routes/OrganizationDashboard/OrganizationStats/SessionUsage/SessionUsageDashboard'
          )
        ),
        key: 'organization-stats-session-usage',
        collapseSideMenu: true,
        exact: true,
        showInNavigateModal: true,
      },
      {
        path: '/organization/:organizationId?/stats/sessions-completion-rate',
        redirect: '/organization/:organizationId?/stats/session-completion-rate',
        key: 'organization-stats-sessions-completion-rate',
        exact: true,
      },
      {
        path: '/organization/:organizationId?/stats/session-completion-rate',
        component: lazyWithRetry(() =>
          import(
            '../routes/OrganizationDashboard/OrganizationStats/SessionCompletionRate/SessionCompletionRateDashboard'
          )
        ),
        key: 'organization-stats-session-completion-rate',
        collapseSideMenu: true,
        exact: true,
        showInNavigateModal: true,
      },
      {
        path: '/organization/:organizationId/school-overview-report',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/SchoolOverviewReport/SchoolOverviewReport')
        ),
        key: 'school-overview-report',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/:organizationId/year-overview-report',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/YearLevelOverviewReport/YearLevelOverviewReport')
        ),
        key: 'year-level-overview-report',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/:classId/weekly-one-on-one',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/RecurrentLessons/RecurrentLessonsDashboard')
        ),
        key: 'organization-recurrent-lessons',
        exact: true,
      },
      {
        path: '/organization/classes/:classId/class-results',
        component: lazyWithRetry(() =>
          import(
            '../routes/OrganizationDashboard/ClassResultsPrecalculated/ClassResultsReportPrecalculated'
          )
        ),
        key: 'class-results-report',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/:classId/assessment-report',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/AssessmentReport/AssessmentReport')
        ),
        key: 'class-assessment-report',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/:classId/assessment-comparison-report',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/AssessmentReport/DemoAssessmentReport')
        ),
        key: 'class-assessment-comparison-report',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/:classId/class-engagement-report',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/ClassEngagementReport/ClassEngagementReport')
        ),
        key: 'class-engagement-report',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/classes/:classId/class-overview-report',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/ClassOverviewReport/ClassOverviewReport')
        ),
        key: 'class-overview-report',
        collapseSideMenu: true,
        exact: true,
      },
      {
        path: '/organization/games/:gameId',
        component: lazyWithRetry(() => import('../routes/OrganizationDashboard/Games/Game')),
        key: 'games',
        exact: true,
      },
    ],
  },

  '/help-center': {
    component: lazyWithRetry(() => import('../layouts/OrganizationDashboard')),
    key: 'organization-dashboard',
    routes: [
      {
        path: '/help-center',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/HelpCenter/HelpCenterHome')
        ),
        key: 'help-center-home',
        exact: true,
      },
      {
        path: '/help-center/category/:category',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/HelpCenter/HelpCenterCategory')
        ),
        key: 'help-center-category',
        exact: true,
      },
      {
        path: '/help-center/:slug',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/HelpCenter/HelpCenterFAQGroup')
        ),
        key: 'help-center-group',
        exact: true,
      },
      {
        path: '/help-center/faq/:slug',
        component: lazyWithRetry(() =>
          import('../routes/OrganizationDashboard/HelpCenter/HelpCenterFAQPage')
        ),
        key: 'help-center-group',
        exact: true,
      },
    ],
  },

  '/admin': {
    component: lazyWithRetry(() => import('../layouts/AdminDashboard')),
    key: 'admin-dashboard',
    routes: [
      {
        path: '/admin/lessons',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Lessons/index')),
        key: 'admin-lessons',
        exact: true,
      },
      {
        path: '/admin/lessons/:lessonId',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Lessons/LessonRedirect')),
        key: 'admin-lessons-redirect',
        exact: true,
      },
      {
        path: '/admin/challenges',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Challenges/index')),
        key: 'admin-challenges',
        exact: true,
      },
      {
        path: '/admin/content-leveling',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/ContentLeveling/ContentLeveling')
        ),
        key: 'content-leveling',
        exact: true,
      },
      {
        path: '/admin/work-logs',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/WorkLogs/index')),
        key: 'instructors-work-logs',
        exact: true,
      },
      {
        path: '/admin/instructors',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Instructors/InstructorsIndex')
        ),
        key: 'instructors-index',
        exact: true,
      },
      {
        path: '/admin/instructor-QA',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/InstructorQA/InstructorQA')
        ),
        key: 'instructor-QA',
      },
      {
        path: '/admin/booking-options',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/BookingOptions/index')),
        key: 'booking-options',
      },
      {
        path: '/admin/bookings',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Bookings')),
        key: 'bookings',
        exact: true,
      },
      {
        path: '/admin/bookings/:bookingId',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/BookingDetails')),
        key: 'booking-details',
        exact: true,
      },
      {
        path: '/admin/booking-requests',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/BookingRequests')),
        key: 'booking-requests',
      },
      {
        path: '/admin/organization-settings',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/OrganizationSettings')),
        key: 'organizationSettings',
      },
      {
        path: '/admin/users',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Users')),
        key: 'users',
        exact: true,
      },
      {
        path: '/admin/users/user/:userId',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Users/User')),
        key: 'users',
        exact: true,
      },
      {
        path: '/admin/users/account-suspensions',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Users/AccountSuspensions')),
        key: 'users-account-suspensions',
        exact: true,
      },
      {
        path: '/admin/topics',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Curriculum')),
        key: 'topics',
      },
      {
        path: '/admin/content-tags',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/ContentTags')),
        key: 'content-tags',
        exact: true,
      },
      {
        path: '/admin/content-tags/custom-tag-trees',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/ContentTags/CustomTagTrees')
        ),
        key: 'custom-tag-trees',
      },
      {
        path: '/admin/content-tags-admin',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/ContentTags/ContentTagsAdmin')
        ),
        key: 'content-tags-admin',
      },
      {
        path: '/admin/instructor-reviews',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/InstructorReviews')),
        key: 'instructor-reviews',
      },
      {
        path: '/admin/student-reviews',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/StudentReviews')),
        key: 'student-reviews',
      },
      {
        path: '/admin/organizations',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Organizations')),
        key: 'organizations',
      },
      {
        path: '/admin/organization-detail/:id',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/OrganizationDetail')),
        key: 'organization-detail',
      },
      {
        path: '/admin/qa-criteria',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/QACriteria/QACriteria')),
        key: 'qa-criteria',
        exact: true,
      },
      {
        path: '/admin/session-assessments',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/SessionAssessments')),
        key: 'assessments',
        exact: true,
      },
      {
        path: '/admin/school-classes',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/SchoolClasses')),
        key: 'schoolClassesList',
        exact: true,
      },
      {
        path: '/admin/school-classes/:id',
        component: lazyWithRetry(() => import('../components/school-classes/EditSchoolClass')),
        key: 'schoolClassItem',
      },
      {
        path: '/admin/daily-activity-log',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/DailyActivityLog')),
        key: 'dailyActivityLog',
      },
      {
        path: '/admin/usage-metrics',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/UsageMetrics')),
        key: 'usageMetrics',
      },
      {
        path: '/admin/staff-roles',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/StaffRoles')),
        key: 'staffRoles',
      },
      {
        path: '/admin/change-password-requests',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/PasswordChangeRequests')),
        key: 'change-password-requests',
      },
      {
        path: '/admin/library',
        component: lazyWithRetry(() => import('../routes/OrganizationDashboard/Library')),
        key: 'admin-library',
        exact: true,
      },
      {
        path: '/admin/feature-flags',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/FeatureFlags')),
        key: 'featureFlags',
        exact: true,
      },
      {
        path: '/admin/flashcards',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Flashcards')),
        key: 'flashcards',
        exact: true,
      },
      {
        path: '/admin/meeopp-core',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/MeeoppCore')),
        key: 'meeoppCore',
        exact: true,
      },
      {
        path: '/admin/iwgts',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Presentation/')),
        key: 'presentations',
        exact: true,
      },
      {
        path: '/admin/presentations/:id/edit',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Presentation/PresentationRedirect')
        ),
        key: 'presentations-edit-redirect',
      },
      {
        path: '/admin/iwgts/:id/edit',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Presentation/PresentationEditor')
        ),
        key: 'presentations-edit',
      },
      {
        path: '/admin/meeopp-core/content-coverage',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/MeeoppCore/ContentCoverage')
        ),
        key: 'core-usage-metrics',
        exact: true,
      },
      {
        path: '/admin/meeopp-core/core-word-aggregate-view',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/MeeoppCore/CoreWordAggregateView')
        ),
        key: 'core-word-aggregate-view',
        exact: true,
      },
      {
        path: '/admin/meeopp-core/search',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/MeeoppCore/CoreWordSearch')
        ),
        key: 'core-word-search',
        exact: true,
      },
      {
        path: '/admin/flashcards/add-flashcards-to-student',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Flashcards/AddWordFlashcardsToStudent')
        ),
        key: 'add-word-flashcards-to-student',
        exact: true,
      },
      {
        path: '/admin/library-stats',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/LibraryStats')),
        key: 'library-stats',
      },
      {
        path: '/admin/points/dashboard',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/PointMetrics')),
        key: 'point-dashboard',
        exact: true,
      },
      {
        path: '/admin/points/query',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/PointMetrics/PointMetricQuery')
        ),
        key: 'point-query',
        exact: true,
      },
      {
        path: '/admin/points/metrics',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/PointMetrics/PointMetrics')
        ),
        key: 'point-metrics',
        exact: true,
      },
      {
        path: '/admin/points/school-health',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/PointMetrics/SchoolHealth')
        ),
        key: 'school-health',
        exact: true,
      },
      {
        path: '/admin/avatars',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Avatars')),
        key: 'avatars',
      },
      {
        path: '/admin/avatar-videos',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/AvatarVideos')),
        key: 'avatar-videos',
      },
      {
        path: '/admin/manimal-cards',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/ManimalCards')),
        key: 'manimal-cards',
      },
      {
        path: '/admin/help-and-support',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/HelpAndSupport')),
        key: 'help-and-support',
        exact: true,
      },
      {
        path: '/admin/help-and-support/faqs',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/HelpAndSupport/HelpAndSupportQuestions')
        ),
        key: 'help-and-support-faqs',
        exact: true,
      },
      {
        path: '/admin/help-and-support/faq/:id',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/HelpAndSupport/CreateEditFaq')
        ),
        key: 'create-edit-faq',
        exact: true,
      },
      {
        path: '/admin/help-and-support/faq',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/HelpAndSupport/CreateEditFaq')
        ),
        key: 'create-edit-faq',
        exact: true,
      },
      {
        path: '/admin/batch-jobs',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/BatchJobs')),
        key: 'batch-jobs',
      },
      {
        path: '/admin/core-packs',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/CorePacks')),
        key: 'core-packs',
        exact: true,
      },
      {
        path: '/admin/bundles',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Bundles')),
        key: 'bundles',
        exact: true,
      },
      {
        path: '/admin/bundles/create',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Bundles/CreateEditForm/CreateForm')
        ),
        key: 'bundle-create',
        exact: true,
      },
      {
        path: '/admin/bundles/manage',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Bundles/BundleManagePage')),
        key: 'bundle-manage',
        exact: true,
      },
      {
        path: '/admin/bundles/:bundleId/edit',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Bundles/CreateEditForm/EditForm')
        ),
        key: 'bundle-edit',
        exact: true,
      },
      {
        path: '/admin/games',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Games')),
        key: 'games',
      },
      {
        path: '/admin/content-tags/content-tag-usage',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/ContentTags/ContentTagUsage')
        ),
        key: 'content-tag-usage',
      },
      {
        path: '/admin/proper-names',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/ProperName')),
        key: 'proper-names',
        exact: true,
      },
      {
        path: '/admin/glossary',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Glossary')),
        key: 'glossary',
        exact: true,
      },
      {
        path: '/admin/library-search-index',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/LibrarySearchIndex')),
        key: 'library-search-index',
        exact: true,
      },
      {
        path: '/admin/translation-report',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/TranslationDashboard')),
        key: 'translation-report',
        exact: true,
      },
      {
        path: '/admin/trainings',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Trainings')),
        key: 'trainings',
        exact: true,
      },
      {
        path: '/admin/trainings/:trainingId/edit',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Trainings/EditTrainingPage')
        ),
        key: 'certification',
        exact: true,
      },
      {
        path: '/admin/event-tracker',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/EventTrackerDashboard')),
        key: 'event-tracker',
        exact: true,
      },
      {
        path: '/admin/worker-tracker',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/WorkerTrackerDashboard')),
        key: 'worker-tracker',
        exact: true,
      },
      {
        path: '/admin/library-refresh',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/LibraryRefreshPage')),
        key: 'library-refresh',
        exact: true,
      },
      {
        path: '/admin/meeopp-core/teaching-card-factory',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/MeeoppCore/TeachingCardFactory')
        ),
        key: 'teaching-card-factory',
        exact: true,
      },
      {
        path: '/admin/meeopp-core/teaching-card-factory/easy-hard',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/MeeoppCore/TeachingCardFactory/SeparateEasyHardCard')
        ),
        key: 'teaching-card-factory-easy-hard',
        exact: true,
      },
      {
        path: '/admin/meeopp-core/teaching-card-factory/view',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/MeeoppCore/TeachingCardFactory/ViewProcessedWords')
        ),
        key: 'teaching-card-factory-view',
        exact: true,
      },
      {
        path: '/admin/self-study-bookings',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/SelfStudyBookings')),
        key: 'self-study-bookings',
        exact: true,
      },
      {
        path: '/admin/translated-strings',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/MeeoppCore/TranslatedStrings')
        ),
        key: 'translated-strings',
        exact: true,
      },
      {
        path: '/admin/curriculum-issues',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/CurriculumIssues')),
        key: 'curriculum-issues',
        exact: true,
      },
      {
        path: '/admin/meeopp-levels',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/MeeOppLevels')),
        key: 'meeopp-levels',
        exact: true,
      },
      {
        path: '/admin/meeopp-topics',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/MeeOppTopics')),
        key: 'meeopp-topics',
        exact: true,
      },
      {
        path: '/admin/image-gallery',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/ImageGallery')),
        key: 'image-gallery',
      },
      {
        path: '/admin/playbook',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/Playbook')),
        key: 'playbook',
        exact: true,
      },
      {
        path: '/admin/playbook/:id',
        component: lazyWithRetry(() =>
          import('../routes/AdminDashboard/Playbook/PlaybookEditPage')
        ),
        key: 'playbook-edit',
        exact: true,
      },
      {
        path: '/admin/recurrent-lessons-request/:recurrentLessonsRequestId',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/RecurrentLessonsRequest')),
        key: 'admin-recurrent-lessons',
        exact: true,
      },
      {
        path: '/admin/content-generation',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/ContentGeneration')),
        key: 'content-generation',
        exact: true,
      },
      {
        path: '/admin/rich-text-content',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/RichTextContent')),
        key: 'rich-text-content',
        exact: true,
      },
      {
        path: '/admin/quiz-creation-assistant',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/QuizCreationAssistant')),
        key: 'quiz-creation-assistant',
        exact: true,
      },
      {
        path: '/admin/meeopp-tncs',
        component: lazyWithRetry(() => import('../routes/AdminDashboard/MeeoppTncs')),
        key: 'meeopp-terms-and-conditions',
        exact: true,
      },
    ],
  },
};

export function getRouterData() {
  return routerConfig;
}
